<template>
  <div class="password_container">
    <div class="top-layout">
      <img src="@/assets/register/Frame 219.png" />
      <div>Listek IOT Platform</div>
    </div>
    <div class="language">
      <el-popover placement="bottom" trigger="click" ref="popover">
        <div class="language-text-layout">
          <div class="language-text" @click="changeLanguage('zh')">{{ $t('account.name10') }}</div>
          <div class="language-text" @click="changeLanguage('en')">English</div>
        </div>
        <div slot="reference">{{ language }}<i class="el-icon-arrow-down"></i></div>
      </el-popover>
    </div>
    <img class="img" src="@/assets/register/Mask group.png" />

    <div class="login_box">
      <div class="fhzsb" @click="goLogin">
        <img src="@/assets/register/Frame.png" />
        <div class="text">{{ $t('retrievePassword.name1') }}</div>
      </div>
      <div class="login">
        <div class="login_name">
          <div>{{ $t('retrievePassword.name2') }}</div>
        </div>
        <el-form ref="passWordFormRef" :model="passWordForm" :rules="passWordFormRules" label-width="0px" class="login_form">
          <el-form-item prop="email">
            <el-input v-model="passWordForm.email" :placeholder="$t('retrievePassword.name3')" :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="code">
              <el-input v-model="passWordForm.code" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input" :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
            </el-form-item>

            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getCode">{{ sendmsg }}</el-button>
            <!-- <div class="code" @click="getCode">{{ $t('retrievePassword.name5') }}</div> -->
          </div>

          <!-- <div class="code-layout">
            <el-form-item prop="code">
              <el-input v-model="passWordForm.code" type="text" prefix-icon="custom-icon" :placeholder="$t('retrievePassword.name4')" class="code-input"></el-input>
            </el-form-item>
            <div class="code">{{ code }}</div>
            <i class="el-icon-refresh" @click="getCode"></i>
          </div> -->

          <el-form-item prop="newPwd">
            <el-input v-model="passWordForm.newPwd" :placeholder="$t('retrievePassword.name6')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>

          <el-form-item prop="againPwd">
            <el-input v-model="passWordForm.againPwd" :placeholder="$t('retrievePassword.name7')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>
        </el-form>

        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="register">{{ $t('retrievePassword.name8') }}</el-button>

        <div class="btns text-style" @click="goLogin">{{ $t('retrievePassword.name9') }}</div>
      </div>
    </div>
    <div class="copyright">{{ $t('retrievePassword.name10') }}</div>
  </div>
</template>
<script>
import { validateEmail, validatePass } from '@/utils/utils.js'
import { updatePwd, emailSend } from '@/api/user.js'
export default {
  data() {
    var validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('retrievePassword.name14')))
      } else if (value !== this.passWordForm.loginPwd) {
        callback(new Error(this.$t('retrievePassword.name15')))
      } else {
        callback()
      }
    }
    return {
      // 这是登录表单的数据对象
      passWordForm: {
        email: '',
        code: '',
        newPwd: '',
        againPwd: ''
      },
      // 这是表单验证规则对象
      passWordFormRules: {
        // 验证用户名是否合法

        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        code: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
          // {
          //   min: 6,
          //   max: 15,
          //   message: '长度在 6 到 15 个字符',
          //   trigger: 'blur'
          // }
        ],
        newPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      },
      isShowYS: false,
      loading: false,
      checked: false,
      code: '',
      codeLoading: false,
      readonlyInput: true,
      isSend: true,
      sendmsg: this.$t('retrievePassword.name12'),
      language: this.$t('account.name10')
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  mounted() {
    // this.getCode()
    const lang = localStorage.getItem('lang')
    this.changeLanguage(lang)
  },
  methods: {
    cancelReadOnly() {
      this.readonlyInput = false
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    showYS() {
      this.isShowYS = !this.isShowYS
    },
    getCode() {
      if (this.passWordForm.email) {
        this.codeLoading = true
        const params = {
          email: this.passWordForm.email,
          type: '1'
        }
        emailSend(params).then(res => {
          if (res.code === 200) {
            this.$message({
              message: this.$t('public.name17'),
              type: 'success'
            })
            this.isSend = false
            let timer = 60
            this.sendmsg = timer + 's'
            this.timeFun = setInterval(() => {
              --timer
              this.sendmsg = timer + 's'
              if (timer === 0) {
                this.isSend = true
                this.sendmsg = this.$t('retrievePassword.name13')
                clearInterval(this.timeFun)
              }
            }, 1000)
          }
          this.codeLoading = false
        }).catch(() => {
          this.codeLoading = false
        })
      }
    },
    goLogin() {
      // this.$router.push('/login')
      this.$router.push({ path: '/login', query: { type: '2' } })
    },
    register() {
      this.$refs.passWordFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          updatePwd(this.passWordForm)
            .then(res => {
              if (res.code === 200) {
                this.$router.push('/login')
              }

              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      if (lang === 'zh') {
        this.language = this.$t('account.name10')
      } else {
        this.language = 'English'
      }
      this.$refs.popover.doClose()
    }
  }
}
</script>
<style lang="scss">
.el-popover {
  min-width: 70px;
}
.custom-icon {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-left: 5px;
  background-image: url(~@/assets/login/Frame.png);
  background-size: cover;
  display: inline-block;
}
.el-select .el-input {
  width: 100%;
}
</style>

<style lang="scss" scoped>
.password_container {
  background: #ffffff;
  background-size: cover;
  width: 100vw;
  height: 100%;
  overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .img {
    width: 100%;
    height: 24.65vw;
    // min-width: 1440px;
    min-height: 355px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
.code-layout {
  display: flex;
  overflow: hidden;
  // align-items: center;
  // height: 37px;
  justify-content: space-between;
  width: 100%;
}
.text-style {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: #0f73e6;
  cursor: pointer;
}

.btns {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.margin-top20 {
  margin-top: 20px;
}

.checked-forget {
  margin-top: -10px;
  width: 100%;
  display: flex;
  align-items: center;
}
.zsb-tyb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
}
.ystk {
  color: #0f73e6;
}

.icon-zsb {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    line-height: 22.4px;
  }
}
.el-icon-refresh {
  margin-bottom: 22px;
  margin-left: 8px;
}
.code-input {
  width: 100%;
}
.code {
  background: #064d9d;
  height: 36px;
  font-size: 14px;
  margin-top: 1px;
  text-align: center;
  width: fit-content;
  color: #fff;
  cursor: pointer;
}

.fhzsb {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  .text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    color: #b9babb;
    margin-left: 4px;
  }
}

.login_box {
  box-shadow: 0px 4px 10px 0px #00000029;
  width: 400px;
  height: 458px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login_box .login_l_img {
  float: left;
  width: 432px;
  height: 440px;
  margin-left: 50px;
}

.login_box .login_l_img img {
  width: 500px;
  height: 440px;
}

.top-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  height: 70px;
  width: 100%;
  background: #0f73e6;
  top: 0px;
  img {
    width: 36px;
    height: 36px;
    margin-left: 30px;
  }
  div {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    text-align: left;
    margin-left: 12px;
    color: #ffffff;
  }
}

.login {
  height: 100%;
  width: 100%;
  padding-top: 0px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: #ffffff;
  border-radius: 0px;
  box-sizing: border-box;
  position: relative;
}

.login_logo {
  width: 120px;
  height: 120px;
  border: 5px solid #93defe;
  border-radius: 100px;
  background: #fff;
  text-align: center;
  line-height: 110px;
  position: absolute;
  top: -60px;
  right: 140px;
}

.login_name {
  width: 100%;
  text-align: center;
}

.login_name div {
  width: 100%;
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  line-height: 33.6px;
  font-weight: 500;
  color: #555555;
  font-family: PingFang SC;
}

.login_logo img {
  width: 100px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}

.copyright {
  font-size: 14px;
  color: #515357;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 30px;
}
}
.language {
  position: absolute;
  right: 60px;
  top: 30px;
  cursor: pointer;
  color: #fff;
  z-index: 10;
  font-size: 14px;
  .el-icon-arrow-down {
    font-size: 18px;
    margin-left: 5px;
  }
}
.language-text-layout {
  display: flex;
  flex-direction: column;
  .language-text {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
  }

  .language-text:hover {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #0f73e6;
  }
}
</style>
